import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LogoTnComponent } from '../logo-tn/logo-tn.component';
import { GlobalService } from 'src/app/core/services/global.service';
import { SocialIconsComponent } from '../../../social-icons/social-icons.component';

@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.scss'],
  standalone:true,
  imports:[
    CommonModule,
    LogoTnComponent,
    SocialIconsComponent
  ]
})
export class SocialMediaComponent {

  constructor(
    public globalService: GlobalService,
  ) { }


}
